module.exports = __webpack_public_path__ + "img/table.58f29bac.png";